import { OrderModel } from '@steelbuy/data-access';
import { CheckoutIllustratedSuccess } from '@steelbuy/ui-domain';
import { useIsVendorFeatureSupported } from '@steelbuy/vendor';
import { CheckoutSuccessDynamicDelivery } from './CheckoutSuccessDynamicDelivery';
import { CheckoutSuccessWrapper } from './CheckoutSuccessWrapper';
import { RoutePath } from '../../router/Routes';

export const CheckoutSuccessMyCart = ({ orderPlaced }: { orderPlaced: OrderModel }) => {
    const isDynamicDeliveryPriceEnabled = useIsVendorFeatureSupported('DYNAMIC_DELIVERY_PRICE');

    if (isDynamicDeliveryPriceEnabled) {
        return <CheckoutSuccessDynamicDelivery orderModelCart={orderPlaced} isCart />;
    }

    return (
        <CheckoutSuccessWrapper>
            <CheckoutIllustratedSuccess orderModelCart={orderPlaced} myOrdersUrl={RoutePath.MY_ORDERS} isCart />
        </CheckoutSuccessWrapper>
    );
};
